import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  withStyles,
} from 'material-ui';
import GenderSwitchStyles from './GenderSwitchStyles';
import Dictionary from '../../model/Dictionary';

const GenderSwitch = ({ value, onChange, classes }) => (
  <div className={classes.root}>
    <FormControl component='fieldset' className={classes.formControl}>
      <FormLabel classes={{ root: classes.label, focused: classes.checked }}>
        {Dictionary.passenger.gender}
      </FormLabel>
      <RadioGroup
        aria-label='gender'
        name='gender'
        className={classes.group}
        value={value}
        onChange={onChange}
      >
        <FormControlLabel
          value='male'
          control={<Radio classes={{ checked: classes.checked }} />}
          label={Dictionary.passenger.male}
        />
        <FormControlLabel
          value='female'
          control={<Radio classes={{ checked: classes.checked }} />}
          label={Dictionary.passenger.female}
        />
      </RadioGroup>
    </FormControl>
  </div>
);

GenderSwitch.propTypes = {
  classes: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default withStyles(GenderSwitchStyles)(GenderSwitch);



// WEBPACK FOOTER //
// ./src/components/genderSwitch/GenderSwitch.js